import { getEnv } from "./envConfig";

function resolveEndpoint() {
    const env = getEnv();
    // Local dev must use relative /api paths so setupProxy forwards to the hosted backend.
    if (env.ENVIRONMENT === 'development') {
        return '';
    }
    return (env.ENDPOINT || '').replace(/\/$/, '');
}

const ENDPOINT = resolveEndpoint();
const env = getEnv();

export { ENDPOINT };
export const KEYCLOAK_URL = env.KEYCLOAK_URL;
export const AUTH = ENDPOINT + '/api/auth';


export const PRIORITIES = ENDPOINT + '/api/priorities';
export const USERS = ENDPOINT + '/api/users';
export const ROLES = ENDPOINT + '/api/roles';
export const CATEGORIES = ENDPOINT + '/api/categories'
export const PRIORITY = '/api/priorities';
export const SUBCATEGORIES = ENDPOINT + '/api/subcategories'
export const SUBCATEGORY_ORGANIZATIONS = ENDPOINT + '/api/subcategory-organizations'
export const SOCIALMEDIASETUPS = ENDPOINT + '/api/social-media-setups'
export const SUPPORTSETUPS = ENDPOINT + '/api/support-setups'
export const RELATIONSHIPS = ENDPOINT + '/api/relationships'
export const SUGGESTORGANIZATIONS = ENDPOINT + '/api/support-organizations'
export const SUBCATEGORYSTEPS = ENDPOINT + '/api/subcategory-steps'
export const DISTRICTS = ENDPOINT + '/api/districts';
export const PROVINCES = ENDPOINT + '/api/provinces';
export const DIVISIONAL_SECRETARIATS = ENDPOINT + '/api/divisional-secretariats';
export const GN_DIVISIONS = ENDPOINT + '/api/gn-divisions';
export const SCHOOLS = ENDPOINT + '/api/schools';
export const POLICE_STATIONS = ENDPOINT + '/api/police-stations';
export const CASES = ENDPOINT + '/api/cases'
export const CASEASSIGNMENTS = ENDPOINT + '/api/case-assignments'
export const FORWARDEDCASES = ENDPOINT + '/api/case-transfers'
export const CASEDESCRIPTION = ENDPOINT + '/api/case-descriptions'
export const EVIDANCE_REQUEST = ENDPOINT + '/api/evidence-requests'
export const EVIDANCE_AVAILABILITY = ENDPOINT + '/api/case-evidence-access-availability'
export const CASE_TIMELINE = ENDPOINT + '/api/case-timelines'
export const CASE_EVIDENCE = ENDPOINT + '/api/case-evidences'
export const CASE_STEPS = ENDPOINT + '/api/case-steps'
export const CASE_SUGGESTED_ORG = ENDPOINT + '/api/case-suggested-organizations'
export const CASE_DETAILS = ENDPOINT + '/api/case-step-details'
export const STEP_LINKS = ENDPOINT + '/api/case-step-links'
export const EVIDANCE_ITEMS = ENDPOINT + '/api/case-evidence-items'
export const EVIDANCE_ITEMS_UPLOAD = ENDPOINT + '/api/case-evidence-items/upload-url'
export const EVIDANCE_ITEMS_UPLOAD_COMPLETE = ENDPOINT + '/api/case-evidence-items/complete-upload'
export const EVIDANCE_ITEMS_DOWNLOAD = ENDPOINT + '/api/case-evidence-items/download-url'
export const CASE_STATISTIC = ENDPOINT + '/api/dashboards/submitted-cases'
export const CASE_CLOSE_REASONS = ENDPOINT + '/api/case-close-reasons'
export const CASE_ASSIGNMENT_CLOSE = ENDPOINT + '/api/case-assignment-closes'
export const ALREADY_COMPLAIN_DATA = ENDPOINT + '/api/already-complained-organizations'
export const SIMILAR_CASES_CHECK_DETAILED = ENDPOINT + '/api/similar-cases/check-detailed';
export const FORWARDEDCOUNT = ENDPOINT + '/api/case-transfers/forwarded/cases'


export const CASE_COMMUNICATIONS = ENDPOINT + '/api/case-communications'
export const CASE_PERSON_ROLES = ENDPOINT + '/api/case-person-roles';
export const CASE_PERSON_ROLE_LINKS = ENDPOINT + '/api/case-person-role-links';
export const CASE_PERSONS = ENDPOINT + '/api/case-persons';
export const ALLCASEEVIDANCE = ENDPOINT + '/api/case-evidence-item-accesses'
export const NOTIFICATIONS = ENDPOINT + '/api/notifications'
export const CASE_OTHER_CATEGORIES = ENDPOINT + '/api/case-other-categories'
export const CASE_EVIDANCE_ACCESS_AVAILABILITY = ENDPOINT + '/api/case-evidence-access-availability'
export const TRANSFER_VISIBLE_STEPS = ENDPOINT + '/api/transfer-visible-steps'
export const Case_Close_Reasons = ENDPOINT + '/api/case-close-reasons'

export const SUBCATEGORY_STEP_ORGANIZATIONS = `${ENDPOINT}/api/subcategory-step-organizations`;
export const ORGANIZATIONS = `${ENDPOINT}/api/organizations`;
export const EMPLOYEES = `${ENDPOINT}/api/employees`;
export const EMPLOYEE_PASSWORD_RESET = `${ENDPOINT}/api/employees/password_reset`;
export const BRANCHES = `${ENDPOINT}/api/branches`;
export const DEPARTMENTS = `${ENDPOINT}/api/departments`;
export const DESIGNATIONS = `${ENDPOINT}/api/designations`;
export const EMPLOYEE_BRANCHES = `${ENDPOINT}/api/employee-branches`;
export const EVIDENCE_ACCESS = `${ENDPOINT}/api/case-evidence-item-accesses`;
export const SUBCATEGORY_QUESTIONS = `${ENDPOINT}/api/subcategory-questions`;
export const CASE_PERSON_CHILDRENS = ENDPOINT + '/api/case-person-childrens';
export const CASE_ADDITIONAL_QUESTIONS = `${ENDPOINT}/api/case-additional-questions`;
export const COMPLAINT_MODES = `${ENDPOINT}/api/complaint-modes`;

export const DISABILITY_TYPES = ENDPOINT + '/api/disability-types';
export const DISABILITIES = ENDPOINT + '/api/disabilities';
export const DISEASE_TYPES = ENDPOINT + '/api/disease-types';
export const DISEASES = ENDPOINT + '/api/diseases';
export const CASE_PERSON_DISEASES = ENDPOINT + '/api/case-person-diseases';
export const CASE_PERSON_DISABILITIES = ENDPOINT + '/api/case-person-disabilities'; 


export const DASHBOARD_OVERVIEW = ENDPOINT + '/api/dashboards/overview'
export const DASHBOARD_OFFICER_STATS = ENDPOINT + '/api/dashboards/officer-stats'
export const DASHBOARD_BRANCH_STATS = ENDPOINT + '/api/dashboards/branch-stats'
export const DASHBOARD_CASE_RESOLUTION_TIME = ENDPOINT + '/api/dashboards/case-resolution-time'
export const DASHBOARD_CASE_DISTRIBUTION_BY_SUBCATEGORY = ENDPOINT + '/api/dashboards/case-distribution-by-subcategory'
export const DASHBOARD_CASE_VOLUME_BY_BRANCH = ENDPOINT + '/api/dashboards/case-volume-by-branch'
export const DASHBOARD_PRIORITY_DISTRIBUTION = ENDPOINT + '/api/dashboards/priority-distribution'
export const DASHBOARD_TOP_CATEGORIES = ENDPOINT + '/api/dashboards/top-categories'
export const DASHBOARD_TOP_SUBCATEGORIES = ENDPOINT + '/api/dashboards/top-subcategories'
export const DASHBOARD_TOP_CATEGORIES_COUNTRY_LEVEL = ENDPOINT + '/api/dashboards/top-categories-country-level'
export const DASHBOARD_TOP_SUBCATEGORIES_COUNTRY_LEVEL = ENDPOINT + '/api/dashboards/top-subcategories-country-level'
export const DASHBOARD_CASE_STATUS_SUMMARY = ENDPOINT + '/api/dashboards/case-status-summary'
export const DASHBOARD_CASES_BY_BRANCH_STATUS = ENDPOINT + '/api/dashboards/cases-by-branch-status'
export const DASHBOARD_CASE_TRENDS_OVER_TIME = ENDPOINT + '/api/dashboards/case-trends-over-time'
export const DASHBOARD_CASE_CREATION_TRENDS = ENDPOINT + '/api/dashboards/case-creation-trends'
export const DASHBOARD_ASSIGNMENT_STATUS_DISTRIBUTION = ENDPOINT + '/api/dashboards/assignment-status-distribution'
export const DASHBOARD_ASSIGNMENT_ACCEPTANCE_RATE = ENDPOINT + '/api/dashboards/assignment-acceptance-rate'
export const DASHBOARD_ORGANIZATION_PERFORMANCE = ENDPOINT + '/api/dashboards/organization-performance'
export const DASHBOARD_CASE_ASSIGNMENT_STATUS_SUMMARY = ENDPOINT + '/api/dashboards/case-assignment-status-summary'

export const DASHBOARD_CASES_BY_REPORTING_TYPE = ENDPOINT + '/api/dashboards/cases-by-reporting-type'
export const DASHBOARD_CASES_BY_DEMOGRAPHIC = ENDPOINT + '/api/dashboards/cases-by-demographic'
export const DASHBOARD_MOST_REPORTED_DISTRICTS = ENDPOINT + '/api/dashboards/most-reported-districts'
export const DASHBOARD_TRANSFER_PERCENTAGE_BY_ORGANIZATION = ENDPOINT + '/api/dashboards/transfer-percentage-by-organization'
export const DASHBOARD_CASES_SOURCE_DISTRIBUTION = ENDPOINT + '/api/dashboards/cases-source-distribution'
export const DASHBOARD_ANONYMOUS_REPORT_RESOLUTION_RATE = ENDPOINT + '/api/dashboards/anonymous-report-resolution-rate'
export const DASHBOARD_OFFICER_COUNT_BY_DESIGNATION = ENDPOINT + '/api/dashboards/officer-count-by-designation'
export const DASHBOARD_SUBMITTED_CASES = ENDPOINT + '/api/dashboards/submitted-cases'
export const DASHBOARD_CASE_DISTRIBUTION_BY_ORGANIZATION = ENDPOINT + '/api/dashboards/case-distribution-by-organization'
export const DASHBOARD_ORGANIZATION_PERFORMANCE_HEATMAP = ENDPOINT + '/api/dashboards/organization-performance-heatmap'
export const DASHBOARD_CASE_CLOSURE_RATE_BY_ORGANIZATION = ENDPOINT + '/api/dashboards/case-closure-rate-by-organization'
export const DASHBOARD_CASE_TIMELINE_STATISTICS = ENDPOINT + '/api/dashboards/case-timeline-statistics'
export const Provinces = ENDPOINT + "/api/provinces";
export const Districts = ENDPOINT + "/api/districts";
export const DivisionalSecretariats = ENDPOINT + "/api/divisional-secretariats";
export const GNDivisions = ENDPOINT + "/api/gn-divisions";
export const PoliceStations = ENDPOINT + "/api/police-stations";
export const EVIDANCE_REQUEST_PUBLIC = ENDPOINT + '/api/evidence-requests/public'
// Case_Person_Contact_Verification
export const Case_public_Verification = ENDPOINT + '/api/case-public-verification';
export const Case_public_Verification_Send = Case_public_Verification + '/request-otp';
export const Case_public_Verification_Verify = Case_public_Verification + '/verify-otp';

export const Schools = ENDPOINT + "/api/schools";

export const REPORTS_GENERATE = ENDPOINT + '/api/reports/generate';
export const REPORTS_TEMPLATES = ENDPOINT + '/api/reports/templates'
export const Case_User_Requests = ENDPOINT + "/api/case-user-requests";

export const Pulic_Create_Case = ENDPOINT + '/publicview/';
export const DASHBOARD_OFFICER_PERFORMANCE = ENDPOINT + '/api/dashboards/officer-case-kpis'
export const DASHBOARD_CALL_CENTER_OFFICER = ENDPOINT + '/api/dashboards/call-center-officer-dashboard';
export const DASHBOARD_CALL_CENTER_OFFICER_LEADERBOARD = ENDPOINT + '/api/dashboards/call-center-officer-leaderboard';
export const DASHBOARD_CALL_CENTER_OFFICER_CASE_STATUS = ENDPOINT + '/api/dashboards/call-center-officer-case-status';
export const DASHBOARD_ORGANIZATION_STATUS = ENDPOINT + '/api/dashboards/organization-case-logging-stats';

export const INCIDENT_LOCATIONS = ENDPOINT + '/api/incident-locations';
export const INCIDENT_LOCATION_TYPES = ENDPOINT + '/api/incident-location-types';

//export const CASE_PERSON_ROLE_REMARK = ENDPOINT + '/api/case-person-role-remarks';

export const ORGANIZATION_CONFIGURATIONS = ENDPOINT + '/api/organization-configurations';
export const CASE_HIERARCHIES = ENDPOINT + '/api/case-hierarchies';
export const CASE_PERSON_ROLE_REMARK = ENDPOINT + '/api/case-person-role-remarks';

export const START_CHAT = ENDPOINT + '/api/case-chats/start';
export const ALL_CHATS = ENDPOINT + '/api/case-chats';

export const SINGLE_CHAT_PUBLIC = ENDPOINT + '/api/case-chats/public/victim/chats';
export const SINGLE_CHAT_PUBLIC_VICTIM = ENDPOINT + '/api/case-chats/public/victim/';
export const SEND_MESSAGE = ENDPOINT + '/api/case-chats/message';
export const SEND_MESSAGE_PUBLIC = ENDPOINT + '/api/case-chats/public/victim-message';

export const CASE_GUIDELINES = ENDPOINT + '/api/case-guidelines';
// export const CASE_PERSON_ROLE_REMARK = ENDPOINT + '/api/case-person-role-remarks';


export const CASE_ORG_REFERENCES = `${ENDPOINT}/api/case-organization-references`;
export const CASE_REMINDER = ENDPOINT + '/api/case-reminders/send-manual';

export const TYPES_OF_COMPLAINT = ENDPOINT + '/api/type-of-complaints';
export const CASE_REFERRED_TO = ENDPOINT + '/api/case-referred-tos';
export const CASE_CASE_REFERRED_TO = ENDPOINT + '/api/case-case-referred-tos';

export const CASE_POLICE_DEVISIONS = ENDPOINT + '/api/police-divisions';
